import Splide from '@splidejs/splide'
import '@splidejs/splide/dist/css/splide.min.css'

const service = document.getElementById('service')

{
  if (service) {
    const sliderEl = document.getElementById('js-support-slider')
    const slider = new Splide(sliderEl, {
      type: 'loop',
      focus: 'center',
      padding: {left: '2rem', right: '2rem'},
      gap: '0.8rem',
      arrows: false,
      pagination: false,
      autoWidth: true,
      autoplay: true,
      interval: 4000,
      speed: 800,
      easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true
        }
      }
    })
    const thumbSliderEl = document.getElementById('js-support-slider-thumb')
    const thumbSlider = new Splide(thumbSliderEl, {
      autoWidth: true,
      gap: '1.2rem',
      rewind: true,
      arrows: false,
      pagination: false,
      drag: false,
      isNavigation: true,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true
        }
      }
    })

    slider.sync(thumbSlider)
    slider.mount()
    thumbSlider.mount()

    const cards = [...sliderEl.querySelectorAll('.splide__slide')]
    cards.forEach((card, index) => {
      card.addEventListener('mouseenter', () => {
        sliderEl.dataset.hoverIndex = index
      })
    })
  }
}
